import React, { Component } from 'react'
import CodeMirror from 'codemirror'
import 'codemirror/mode/htmlmixed/htmlmixed'

export default class extends Component {
  componentDidMount () {
    this.editor = CodeMirror.fromTextArea(this.textarea, {
      mode: 'htmlmixed',
      lineNumbers: true,
      lineWrapping: true
    })
    this.editor.on('change', this.onChange)
    // refresh after sheet animates
    setTimeout(() => this.editor.refresh(), 250)
  }

  componentWillReceiveProps (props) {
    if (this.editor && this.editor.getValue() !== props.value) {
      this.editor.setValue(props.value || '')
    }
  }

  componentDidUpdate () {
    this.editor && this.editor.refresh()
  }

  onChange = e => {
    this.props.onChange(e.getValue())
  }

  render () {
    const {value} = this.props

    return <div className='content-editor code'>
      <div className='header'>
        <span className='title'>Code</span>
      </div>
      <textarea ref={c => (this.textarea = c)} defaultValue={value} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/CodeEditor.js